export enum ContractorCategory {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
